import { useHistory } from 'react-router-dom';
import {
  DeleteOutline,
  Edit,
  EditNote,
  FolderOpenOutlined,
  Download,
  InfoOutlined,
  LinkOutlined,
} from '@mui/icons-material';
import type { ActionType } from '../knowledge-base-list';
import { LabelDate, MoreActions } from '../../../../../components';

export type ActionCardPayload = {
  action: ActionType;
  id?: string;
  name?: string;
  metadata_fields?: string | Record<string, unknown>;
};
type KnowlegeCardProps = {
  item: any;
  onClick: (payload: ActionCardPayload) => void;
};

export const KnowledgeCard: React.FC<KnowlegeCardProps> = ({
  item,
  onClick,
}) => {
  const history = useHistory();

  return (
    <div
      className="w-full max-w-[370px] h-[210px] flex flex-col bg-white rounded-card cursor-pointer p-6 hover:border-[2px] hover:border-primary transition-all duration-200"
      onClick={() => {
        history.push(`/knowledge_management/${item.id}`);
      }}
    >
      <div className="sm:h-2/3 h-3/4 flex flex-col justify-between">
        <div className="flex justify-between">
          <div className="p-2 bg-select rounded-sm ">
            <FolderOpenOutlined
              className="text-mainText"
              style={{ fontSize: 28 }}
            />
          </div>
          <MoreActions
            options={[
              {
                label: 'Rename',
                icon: <Edit />,
                onClick: () =>
                  onClick({
                    action: 'rename',
                    id: item.id,
                    name: item.name,
                    metadata_fields: item?.metadata_fields
                      ? JSON.stringify(item?.metadata_fields || '{}')
                      : '',
                  }),
              },
              {
                label: 'Download',
                icon: <Download />,
                onClick: () =>
                  onClick({ action: 'download', id: item.id, name: item.name }),
              },
              {
                label: 'Delete',
                icon: <DeleteOutline />,
                onClick: () => onClick({ action: 'delete', id: item.id }),
              },
              {
                label: 'Add content by URL',
                icon: <LinkOutlined />,
                onClick: () =>
                  onClick({ action: 'extend_by_url', id: item.id }),
              },
              {
                label: 'Show Metadata',
                icon: <InfoOutlined />,
                onClick: () =>
                  onClick({
                    action: 'show_metadata',
                    id: item.id,
                    metadata_fields: item?.metadata_fields,
                  }),
              },
              {
                label: 'Edit Metadata',
                icon: <EditNote />,
                onClick: () =>
                  onClick({
                    action: 'edit_metadata',
                    id: item.id,
                    name: item.name,
                    metadata_fields: item?.metadata_fields,
                  }),
              },
            ]}
          />
        </div>

        <div className="flex flex-col h-1/2">
          <div className="text-3xl font-semibold text-mainText leading-snug line-clamp-2">
            {item.name}
          </div>
        </div>
      </div>
      <div className="mt-auto">
        <LabelDate
          date={item.created_at || ''}
          label={`${item.resource_count ?? 0} Sources`}
          className="text-textSecondary text-mainText text-small"
          formatDate="dd MMM yy"
        />
      </div>
      <div className="text-secondary text-tiny mt-2">
        <span className="mr-2">Total Size:</span>
        <span className="font-semibold">{item?.total_size}</span>
      </div>
    </div>
  );
};
